<template>
    <slot></slot>
</template>

<script lang="ts" setup>

import type {Department, Employee, Location} from "../types.ts";
import {provide} from "vue";
import EmployeeProvider from "../EmployeeProvider.ts";

interface Props {
    employees: Array<Employee>
    departments: Array<Department>
    locations: Array<Location>
}

const props = defineProps<Props>();

provide("employeeProvider", new EmployeeProvider(
    props.employees,
    props.departments,
    props.locations
));

</script>
